/**
 * Shared preference type icon components.
 *
 * Belongs here: SVG icons.
 * Does not belong here: routing.
 */
import React from 'react'
import type { CategoryIconProps } from '../../../../../../icons/CategorySvgIcon'

export const DebtPreferenceIcon: React.FC<CategoryIconProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    className={className}
    aria-hidden
  >
    <g clipPath="url(#debt-preference-clip)">
      <rect width="28" height="28" fill="white" fillOpacity={0.0901961} />
      <path
        d="M22.5179 11.1606V8.32129L15.8929 1.69629H3.58928C3.08726 1.69629 2.60581 1.89571 2.25083 2.25069C1.89585 2.60567 1.69643 3.08712 1.69643 3.58915V24.4106C1.69643 24.9126 1.89585 25.3941 2.25083 25.749C2.60581 26.1039 3.08726 26.3034 3.58928 26.3034H13.0536"
        stroke="#232323"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.3571 14.9463H15.8929C15.3702 14.9463 14.9464 15.37 14.9464 15.8927V18.4248C14.9464 21.9995 17.2338 25.173 20.625 26.3034C24.0162 25.173 26.3036 21.9995 26.3036 18.4248V15.8927C26.3036 15.37 25.8798 14.9463 25.3571 14.9463Z"
        stroke="#232323"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.42857 8.32129H15.8929"
        stroke="#232323"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.42857 14H11.1607"
        stroke="#232323"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.42857 19.6782H11.1607"
        stroke="#232323"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="debt-preference-clip">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const FallbackPreferenceIcon: React.FC<CategoryIconProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    className={className}
    aria-hidden
  >
    <path
      d="M9.56033 4.66603C9.56033 5.70462 9.97292 6.70068 10.7073 7.43508C11.4417 8.16948 12.4378 8.58206 13.4764 8.58206C14.515 8.58206 15.5111 8.16948 16.2455 7.43508C16.9799 6.70068 17.3925 5.70462 17.3925 4.66603C17.3925 3.62743 16.9799 2.63138 16.2455 1.89698C15.5111 1.16258 14.515 0.75 13.4764 0.75C12.4378 0.75 11.4417 1.16258 10.7073 1.89698C9.97292 2.63138 9.56033 3.62743 9.56033 4.66603Z"
      stroke="#232323"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.2879 9.55957C21.2493 9.55957 20.2532 9.97215 19.5188 10.7065C18.7844 11.4409 18.3718 12.437 18.3718 13.4756C18.3718 14.5142 18.7844 15.5103 19.5188 16.2446C20.2532 16.979 21.2493 17.3916 22.2879 17.3916C23.3265 17.3916 24.3226 16.979 25.057 16.2446C25.7914 15.5103 26.204 14.5142 26.204 13.4756C26.204 12.437 25.7914 11.4409 25.057 10.7065C24.3226 9.97215 23.3265 9.55957 22.2879 9.55957Z"
      stroke="#232323"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.56033 22.2852C9.56033 23.3238 9.97292 24.3198 10.7073 25.0542C11.4417 25.7886 12.4378 26.2012 13.4764 26.2012C14.515 26.2012 15.5111 25.7886 16.2455 25.0542C16.9799 24.3198 17.3925 23.3238 17.3925 22.2852C17.3925 21.2466 16.9799 20.2505 16.2455 19.5161C15.5111 18.7817 14.515 18.3691 13.4764 18.3691C12.4378 18.3691 11.4417 18.7817 10.7073 19.5161C9.97292 20.2505 9.56033 21.2466 9.56033 22.2852Z"
      stroke="#232323"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66608 9.55957C3.62747 9.55957 2.6314 9.97215 1.897 10.7065C1.16259 11.4409 0.75 12.437 0.75 13.4756C0.75 14.5142 1.16259 15.5103 1.897 16.2446C2.6314 16.979 3.62747 17.3916 4.66608 17.3916C5.70469 17.3916 6.70077 16.979 7.43517 16.2446C8.16958 15.5103 8.58217 14.5142 8.58217 13.4756C8.58217 12.437 8.16958 11.4409 7.43517 10.7065C6.70077 9.97215 5.70469 9.55957 4.66608 9.55957Z"
      stroke="#232323"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
